/**
 * Render scale utilities for canvas coordinate systems.
 */

import type { ScaleFactors } from '@/components/blocks/Types'
import type { FieldCoordinateSystem } from '@/utils/Coordinates'

/**
 * Create scale factors matching the pixel coordinate system for animation overlays.
 * Player and stroke scale to coordSystem.scale; font stays at 1.0.
 */
export function createPixelScaleFactors(coordSystem: FieldCoordinateSystem): ScaleFactors {
	return {
		player: coordSystem.scale,
		playerStroke: coordSystem.scale,
		playerFont: 1.0,
	}
}
